// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import { BodyText } from '@paypalcorp/pp-react'

// TYPES
import { ShimmeringComponent } from '../types'

/**
 * The LoadingShimmer component returns an PP-React element in the loading state
 * @param ShimmeringComponent a PP-React component that supports the "isLoading" prop
 */
export default function LoadingShimmer({
  ShimmeringComponent,
}: {
  ShimmeringComponent?: ShimmeringComponent
}) {
  const Component = ShimmeringComponent || BodyText
  return <Component isLoading></Component>
}
